import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

import { IUser } from '@crm-framework/auth';

import { ILeadResponseModel, EMPTY_VALUE } from '@crm-lead/base';
import {
  getValueOfKeyById,
  IBusinessUnitModel,
  ICountryModel,
  ILanguageModel,
} from '@crm-package/dictionaries';
import { shortDateTimeFormat } from '@crm-package/app';
import { USER_RIGHTS } from '@crm-package/auth';

import { ILeadMappedModel, IStoreWithShortInfoState } from './types';
import { STORE_NAME } from './store';

export const getLeadShortInfoState = (state: IStoreWithShortInfoState) =>
  state[STORE_NAME];

interface IGetLeadMappedValue {
  lead: ILeadResponseModel;
  languages: ILanguageModel[];
  businessUnits: IBusinessUnitModel[];
  countries: ICountryModel[];
}

const getValue = (value?: string | null) => value ?? EMPTY_VALUE;

const getDate = (iso?: string) => {
  if (iso) {
    return format(parseISO(iso), shortDateTimeFormat);
  }

  return EMPTY_VALUE;
};

interface IGetLeadMappedValue {
  lead: ILeadResponseModel;
  languages: ILanguageModel[];
  businessUnits: IBusinessUnitModel[];
  countries: ICountryModel[];
}

export const leadInfoMapper = ({
  lead,
  businessUnits,
  countries,
  languages,
}: IGetLeadMappedValue): ILeadMappedModel => ({
  fullName: getValue(lead!.fullName),
  isOnline: lead!.isOnline ?? false,
  deviceType: lead!.deviceType,
  Language: getValueOfKeyById({
    id: lead!.languageId,
    arrayForSearch: languages,
    keyName: 'name',
  }),
  Country: getValueOfKeyById({
    id: lead!.countryId,
    arrayForSearch: countries,
    keyName: 'name',
  }),
  'Business Unit': getValueOfKeyById({
    id: lead!.businessUnitId,
    arrayForSearch: businessUnits,
    keyName: 'name',
  }),
  'Vip Manager': getValue(lead!.vipManagerName),
  'Account Manager': getValue(lead!.conversionAgentName),
  'Closer Manager': getValue(lead!.closerManagerName),
  'Retention Manager': getValue(lead!.retentionManagerName),
  'Last Login Date': getDate(lead!.lastLoginDate),
});

export const checkRightsForWatchLeadInfo = (
  userRights?: IUser['rights']
): boolean => {
  const RIGHTS_FOR_SHOW_LEAD_INFO = [
    USER_RIGHTS.DETAILS_VIEW_ASSIGNED,
    USER_RIGHTS.DETAILS_VIEW_ALL,
  ];

  if (userRights) {
    let hasOneOfRights = false;
    let hasAccessCrmRight = false;

    for (let i = 0; i < userRights.length; i++) {
      if (hasOneOfRights && hasAccessCrmRight) break;

      const iterationRight = userRights[i];

      if (!hasOneOfRights) {
        hasOneOfRights = RIGHTS_FOR_SHOW_LEAD_INFO.some(
          ($right) => $right === iterationRight
        );
      }

      if (!hasAccessCrmRight) {
        hasAccessCrmRight = USER_RIGHTS.ACCESS_CRM === iterationRight;
      }
    }

    return hasOneOfRights && hasAccessCrmRight;
  }

  return false;
};
